/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/base/style/index';import 'element-plus/es/components/dialog/style/index';
import { ElCheckbox as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/index';import 'element-plus/es/components/checkbox/style/index';
import __unplugin_components_3 from '/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/b2b/trade-bms/src/components/ClientOnly/index.vue';
import { ElCascader as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/index';import 'element-plus/es/components/cascader/style/index';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/index';import 'element-plus/es/components/form-item/style/index';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/index';import 'element-plus/es/components/input/style/index';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04beabd0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trade-settle-form__header"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "company-sug"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "captcha-innerbox"
};
const _hoisted_6 = {
  class: "agree-box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "agrt-tip"
}, [/*#__PURE__*/_createTextVNode(" 点击提交代表您同意 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://b2b.baidu.com/agrt/seller?v=20240130",
  target: "_blank"
}, "《商家服务协议》"), /*#__PURE__*/_createElementVNode("a", {
  href: "https://b2b.baidu.com/agrt/privacy?v=20231204",
  target: "_blank"
}, "《隐私政策》")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "discount-tips"
}, " 提交联系方式即可获赠限时优惠，一个手机号或企业名称仅可领取一次，我们会安排专业顾问与您尽快联系！ ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "accredit-dialog-warp"
}, " 是否允许获取您在百度注册账号时填写的联系人与手机号 ", -1));
const _hoisted_10 = {
  class: "dialog-footer"
};
import { reactive, computed, ref } from 'vue';
import { ElButton, ElForm, ElMessage, ElMessageBox } from 'element-plus';
import { timeFormat } from '@baidu/b2b-util';
import { usePhoneCaptcha } from './usePhoneCaptcha';
import TButton from '@/components/TButton/index.vue';
import { useStore } from '@/store';
import { scLog } from '@/base/log/sclog';
import { isMobileUa } from '@/base/utils';
import { getCompanySuggestListApi, getPhoneAndNameApi, getSettleAreaApi, postSubmitSettleFormApi } from '@/base/api/settle';
import { getQueryString } from '@/base/utils/url';
import { SHOW_MESSAGE_MODE } from '@/components/TForm/types';
import { showElMessage } from '@/base/utils/message';
/**
 * 网络错误提示信息
 *
 * @const
 * @type {string}
 */
const NET_ERROR_TIP = '网络错误，请重试';
// 表单校验规则
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    title: {
      default: '我想成为爱采购商家'
    },
    requireAsteriskPosition: {
      default: 'left'
    },
    btnProps: {
      default: () => ({
        type: 'danger',
        size: 'large',
        round: true
      })
    },
    btnText: {
      default: '立即入驻'
    },
    showMessageMode: {
      default: SHOW_MESSAGE_MODE.normal
    }
  },
  setup(__props) {
    const formRules = {
      entName: [{
        required: true,
        message: '请输入企业名称',
        trigger: 'blur'
      }],
      // location: [
      //     {
      //         type: 'array',
      //         required: true,
      //         message: '请选择所在地',
      //         trigger: 'change',
      //     },
      // ],
      contact: [{
        required: true,
        message: '请输入联系人',
        trigger: 'change'
      }],
      phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'change'
      }, {
        pattern: /^1\d{10}$/,
        message: '手机号格式错误',
        trigger: 'change'
      }]
    };
    const props = __props;
    const settleFormRef = ref(null);
    const store = useStore();
    const isMobile = computed(() => isMobileUa());
    // 表单数据
    const form = reactive({
      // 品牌名、企业名
      entName: '',
      // 企业的id
      bid: '',
      // 所在地区
      location: [],
      contact: '',
      phone: '',
      captcha: ''
    });
    // 省市区地区数据
    const location = ref([]);
    // 是否同意协议
    const isAgree = ref(false);
    // 表单提交中
    const formSubmiting = ref(false);
    // sug loading
    const sugLoading = ref(false);
    const sugList = ref([]);
    const showSug = ref(false);
    const sugFetchTime = ref(0);
    // const contactChange = ref<boolean>(false);
    const showAccreditModal = ref(false);
    // isAccredit 是否已授权获取百度注册账号的联系人名称及联系方式;
    // 只有在百度账号已登录时才会调起授权提示层，所以已登录时，默认还没授权，这个字段初始化时是 false;
    // 未登录时不需要调起授权提示层，所以认为是已授权，字段初始化是 true;
    const isAccredit = ref(true);
    const hideSugTimer = ref();
    // 百度账号是否登录了
    const isPassportLogin = computed(() => {
      return store.state.user.isLogin && store.state.user.loginType === 'passport';
    });
    const locationPoperClass = computed(() => {
      const defaultClass = 'settle-location-cascader';
      const mobileClass = isMobile.value ? 'settle-location-cascader--mobile' : '';
      return mobileClass ? `${defaultClass} ${mobileClass}` : defaultClass;
    });
    watch(isPassportLogin, newVal => {
      isAccredit.value = !newVal;
    }, {
      immediate: true
    });
    onMounted(() => {
      getLocList();
    });
    /**
     * 企业名称输入框获得焦点 显示 sug
     */
    function sugFocus() {
      clearTimeout(hideSugTimer.value);
      showSug.value = true;
    }
    function sugBlur() {
      clearTimeout(hideSugTimer.value);
      hideSugTimer.value = setTimeout(() => {
        const companyInfo = sugList.value.find(item => item.compname === form.entName);
        form.bid = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.bid) || '';
        showSug.value = false;
      }, 300);
    }
    /**
     * 获取企业列表
     */
    async function getCompanyList(query = '') {
      sugFetchTime.value = +new Date();
      const fetchTime = sugFetchTime.value;
      if (query.trim() !== '') {
        showSug.value = true;
        sugLoading.value = true;
        try {
          var _res$data;
          const res = await getCompanySuggestListApi({
            query,
            q: query
          });
          if (fetchTime !== sugFetchTime.value) {
            return;
          }
          sugList.value = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.filter(item => !!(item.compname || '').trim());
          sugLoading.value = false;
        } catch (error) {
          console.log(error);
          sugLoading.value = false;
          sugList.value = [];
        }
      } else {
        sugList.value = [];
      }
      form.bid = '';
    }
    /**
     * 在搜索出的企业 sug list 中选中某个企业
     */
    function selectCompany(data) {
      form.entName = data.compname;
      form.bid = data.bid;
    }
    /**
     * 获取省市区列表
     */
    async function getLocList() {
      try {
        const res = await getSettleAreaApi();
        const data = (res === null || res === void 0 ? void 0 : res.data) || [];
        const formatData = (item = []) => {
          return item.map(info => {
            var _info$children;
            if ((_info$children = info.children) !== null && _info$children !== void 0 && _info$children.length) {
              info.children = formatData(info.children);
            }
            return {
              value: info.value,
              label: info.label,
              children: info.children || []
            };
          });
        };
        location.value = formatData(data);
      } catch (error) {
        console.log(error);
        location.value = [];
      }
    }
    function locationChange(value) {
      form.location = value;
    }
    async function handleAccredit() {
      showAccreditModal.value = false;
      const res = await getPhoneAndNameApi();
      const {
        data,
        status = '',
        msg = ''
      } = res;
      if (+status !== 0) {
        ElMessage.error(msg);
        isAccredit.value = true;
        return;
      }
      isAccredit.value = true;
      form.phone = data.phone || '';
      form.contact = data.username || '';
    }
    /**
     * 打开授权model
     * @param res 选择的内容
     */
    function handleAccreditInputFocus(e) {
      showAccreditModal.value = !isAccredit.value;
    }
    function handleCancelAccredit() {
      showAccreditModal.value = false;
      isAccredit.value = true;
    }
    // isSubmitValidate: 是否是提交表单时的验证
    // 只要点击了一次提交表单按钮后这个值就会置为 ture, 且不可逆, 然后验证码失去焦点时 '校验验证码’ 的逻辑就再也不会执行了
    // (本表单是从爱采购的 settleForm 表单抄过来的，这个逻辑有点奇怪，不知道为什么这么设计)
    const isSubmitValidate = ref(false);
    const {
      verifyStatus,
      verifyRetryTime,
      handleVerify,
      validVerify
    } = usePhoneCaptcha(settleFormRef, form, isSubmitValidate);
    /**
     * 提交入驻表单
     */
    function handleSubmit() {
      var _settleFormRef$value;
      if (formSubmiting.value) {
        return;
      }
      // 用于短信验证组件 true 时，便阻止了验证码失去焦点时的 验证码验证接口请求
      isSubmitValidate.value = true;
      // 埋点
      scLog('click', {
        elem: 'b2b-settle-submit-click'
      });
      // 协议
      if (!isAgree.value) {
        ElMessage.error('请同意相关协议');
        return;
      }
      (_settleFormRef$value = settleFormRef.value) === null || _settleFormRef$value === void 0 || _settleFormRef$value.validate(async (valid, failedFields) => {
        if (!valid) {
          // 如果显示错误信息的形式为 taost 弹层
          if (props.showMessageMode === SHOW_MESSAGE_MODE.toast && failedFields) {
            // 过滤出第一个校验错误信息
            const failedField = failedFields[Object.keys(failedFields)[0]][0];
            showElMessage({
              type: 'error',
              center: true,
              message: failedField.message,
              duration: 3000
            });
          }
          // 校验失败埋点
          scLog('click', {
            elem: 'b2b-settle-form-valid-fail',
            ext: JSON.stringify(failedFields)
          });
          return;
        }
        // 埋点
        scLog('click', {
          elem: 'b2b-settle-submit-valid-success-click'
        });
        formSubmiting.value = true;
        // 活动 id
        const activity = getQueryString('activity');
        let list = {
          ...(!form.bid ? {
            province: form.location[0],
            city: form.location[1],
            county: form.location[2]
          } : {}),
          ...form
        };
        delete list.location;
        // 会员类型枚举值
        const typeEnum = {
          normal: 1,
          senior: 2
        };
        const params = {
          type: typeEnum.normal,
          phone_num: form.phone,
          captcha: form.captcha,
          list,
          activity,
          dispInfo: {
            from: 'chuhaiyi-detail'
          }
        };
        try {
          var _settleFormRef$value2;
          const res = await postSubmitSettleFormApi(params);
          formSubmiting.value = false;
          const {
            status,
            msg,
            data
          } = res;
          if (Number(status) !== 0) {
            // 埋点
            scLog('click', {
              elem: 'b2b-settle-submit-fail',
              ext: JSON.stringify({
                status: status
              })
            });
            return ElMessageBox.alert(msg || NET_ERROR_TIP, '失败', {
              type: 'error',
              confirmButtonText: '确定'
            });
          }
          // 埋点
          scLog('click', {
            elem: 'b2b-settle-submit-success'
          });
          // emit('submitSuccess');
          // 如果有优惠券，则展示优惠券相关信息
          let content = '';
          if (data && data.preferential && data.e_time) {
            const endTime = timeFormat(new Date(data.e_time * 1000), 'yyyy年M月d日 hh:mm');
            content = `
                    <div class="coupon-msg">
                        <p>恭喜您获得购买<em>${data.preferential}</em>延长权益。</p>
                        <p>兑换方法：凭所填信息与服务商达成合作，在<em>${endTime}</em>前完成会员入驻，即可享受权益。</p>
                    </div>
                `;
          }
          ElMessageBox.alert(content, msg || '成功', {
            type: 'success',
            showClose: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            lockScroll: true,
            customClass: 'b2b-settle-form-result-popup',
            customStyle: {
              width: isMobile.value ? '90%' : '400px'
            }
          });
          // 成功后清空表单内容
          (_settleFormRef$value2 = settleFormRef.value) === null || _settleFormRef$value2 === void 0 || _settleFormRef$value2.resetFields();
          isAccredit.value = false;
        } catch (err) {
          // 埋点
          scLog('click', {
            elem: 'b2b-settle-submit-fail'
          });
          formSubmiting.value = false;
          ElMessageBox.alert(NET_ERROR_TIP, '失败', {
            type: 'error',
            showClose: false,
            confirmButtonText: '确定',
            lockScroll: true,
            customClass: 'b2b-settle-form-result-popup',
            customStyle: {
              width: isMobile.value ? '90%' : '400px'
            }
          });
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_cascader = __unplugin_components_2;
      const _component_client_only = __unplugin_components_3;
      const _component_el_checkbox = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['trade-settle-form', `trade-settle-form-${isMobile.value ? 'b2b-wise' : 'b2b-pc'}`])
      }, [_createElementVNode("header", _hoisted_1, [_createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1)]), _createVNode(_unref(ElForm), {
        ref_key: "settleFormRef",
        ref: settleFormRef,
        inline: isMobile.value,
        model: form,
        rules: formRules,
        "label-width": "100%",
        "hide-required-asterisk": false,
        "require-asterisk-position": _ctx.requireAsteriskPosition,
        "show-message": true,
        "inline-message": true,
        size: "default",
        onValidate: _cache[6] || (_cache[6] = $event => _ctx.$emit('validate', $event))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "企业名称",
          prop: 'entName',
          required: "",
          class: "entname-inputbox"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.entName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.entName = $event),
            placeholder: "请输入企业名称",
            maxlength: 50,
            clearable: true,
            onBlur: sugBlur,
            onEnter: sugBlur,
            onFocus: sugFocus,
            onInput: getCompanyList
          }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sugList.value, item => {
            return _openBlock(), _createElementBlock("p", {
              key: item.bid,
              class: _normalizeClass({
                compname: true,
                'is-mate': item.compname === form.entName
              }),
              onClick: _withModifiers($event => selectCompany(item), ["stop"])
            }, _toDisplayString(item.compname), 11, _hoisted_4);
          }), 128))], 512), [[_vShow, showSug.value && sugList.value.length]])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_form_item, {
          prop: "location",
          label: "所在地",
          rules: [{
            type: 'array',
            required: !form.bid && !!form.entName && !showSug.value,
            message: '请选择所在地',
            trigger: 'change'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_client_only, null, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: form.location,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.location = $event),
              filterable: "",
              clearable: "",
              trigger: "hover",
              options: location.value,
              "popper-class": locationPoperClass.value,
              placeholder: "请选择所在地",
              onChange: locationChange
            }, null, 8, ["modelValue", "options", "popper-class"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules"]), [[_vShow, !form.bid && form.entName && !showSug.value]]), _createVNode(_component_el_form_item, {
          prop: "contact",
          label: "联系人",
          required: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.contact,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.contact = $event),
            placeholder: "请输入联系人",
            maxlength: 20,
            onFocus: handleAccreditInputFocus
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "手机号码",
          prop: 'phone',
          required: true,
          class: "phone-inputbox"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.phone = $event),
            placeholder: "请输入手机号码",
            maxlength: 11,
            onEnter: _unref(handleVerify),
            onFocus: handleAccreditInputFocus
          }, null, 8, ["modelValue", "onEnter"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "验证码",
          prop: "captcha",
          class: "captcha",
          rules: [{
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }, {
            min: 4,
            message: '验证码长度错误',
            trigger: 'blur'
          }, {
            validator: _unref(validVerify),
            trigger: 'blur'
          }]
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
            modelValue: form.captcha,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.captcha = $event),
            placeholder: "请输入验证码",
            maxlength: 6
          }, null, 8, ["modelValue"]), _createElementVNode("button", {
            class: _normalizeClass({
              'captcha-btn': true,
              'disabled': _unref(verifyStatus) !== 0
            }),
            type: "button",
            style: {
              color: '#249AFE'
            },
            onClick: _cache[5] || (_cache[5] = _withModifiers(
            //@ts-ignore
            (...args) => _unref(handleVerify) && _unref(handleVerify)(...args), ["prevent"]))
          }, _toDisplayString(_unref(verifyStatus) === 2 ? `${_unref(verifyRetryTime)}s` : '获取验证码'), 3)])]),
          _: 1
        }, 8, ["rules"])]),
        _: 1
      }, 8, ["inline", "model", "require-asterisk-position"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_checkbox, {
        modelValue: isAgree.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => isAgree.value = $event),
        size: "small"
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(TButton, _mergeProps(_ctx.btnProps, {
        class: "submit-btn",
        onClick: handleSubmit
      }), {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(formSubmiting.value ? '提交中' : _ctx.btnText), 1)]),
        _: 1
      }, 16), _hoisted_8, _createVNode(_component_el_dialog, {
        modelValue: showAccreditModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showAccreditModal.value = $event),
        title: "授权功能",
        "ok-text": "允许",
        "class-name": "accredit-dialog",
        width: isMobile.value ? '80%' : 400,
        onClose: handleCancelAccredit
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_unref(ElButton), {
          onClick: handleCancelAccredit
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: handleAccredit
        }, {
          default: _withCtx(() => [_createTextVNode("允许")]),
          _: 1
        })])]),
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }, 8, ["modelValue", "width"])], 2);
    };
  }
});